import CASI_THINKING_GREY from "assets/images/casi-thinking-grey-44px.webm";
import CASI_THINKING_WHITE from "assets/images/casi-thinking-white-184px.webm";
import React from "react";

interface CasiThinkingVideoProps {
    color: "white" | "grey";
    cssClassName?: string;
}
const CasiThinkingVideo = (props: CasiThinkingVideoProps) => {
    const { color, cssClassName } = props;
    return (
        <video
            autoPlay
            loop
            muted
            playsInline
            src={color === "white" ? CASI_THINKING_WHITE : CASI_THINKING_GREY}
            className={cssClassName}
        />
    );
};
export default CasiThinkingVideo;
